"use client";

import { TitleH3 } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const KitchenOption = () => {
  const t = useTranslations("floorPlanDesigns.kitchenOption");

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col gap-5">
        <TitleH3 title={t("title")} />
        <p className="text-ring">{t("text")}</p>
      </div>
    </div>
  );
};

export default KitchenOption;
